import { useTranslation } from 'react-i18next';

import type { InvoiceTemplateIntervalStatus, RecurringInvoiceTemplate } from '~/api/invoiceTemplates/types';
import type { IconName } from '~/components/Icon/Icon';

import { InfoBlock, StatusCard, Text } from '~/components';
import { useIntl } from '~/hooks/useIntl';

import { metaStyle, statusStyle } from './InvoiceTemplateDetail.css';

const statusIcons: Record<InvoiceTemplateIntervalStatus, IconName> = {
  Live: 'Play',
  Paused: 'Pause',
};

type Props = {
  invoiceTemplate: RecurringInvoiceTemplate;
};

export const InvoiceTemplateStatusCard = ({ invoiceTemplate }: Props) => {
  const { formatDate } = useIntl();
  const { t } = useTranslation(['invoiceTemplates']);

  return (
    <StatusCard
      className={statusStyle}
      icon={statusIcons[invoiceTemplate.intervalStatus]}
      title={t(`invoiceTemplates:terminology.intervalStatus.cases.${invoiceTemplate.intervalStatus}`)}
    >
      <div className={metaStyle}>
        <InfoBlock label={t('invoiceTemplates:details.stats.recurring.label')} variant="caps">
          <Text>{t(`invoiceTemplates:terminology.interval.cases.${invoiceTemplate.interval}`)}</Text>
        </InfoBlock>

        <InfoBlock label={t('invoiceTemplates:details.stats.nextInvoice.label')} variant="caps">
          <Text>{formatDate(invoiceTemplate.nextInvoiceAt)}</Text>
        </InfoBlock>
      </div>
    </StatusCard>
  );
};
